/* @flow */
export default from './FlexTable'
export FlexTable from './FlexTable'
export FlexColumn from './FlexColumn'
export SortDirection from './SortDirection'
export SortIndicator from './SortIndicator'



/** WEBPACK FOOTER **
 ** ./source/FlexTable/index.js
 **/